<template>
    <Paper class="after-login-layout">
        <div class="after-login-index">
            <div class="after-login-index-left">
                <!-- 解析量、注册量 -->
                <el-row type="flex" justify="space-between" class="after-login-data-list">
                    <el-col class="after-login-data" type="flex">
                        <el-row type="flex" class="row-bg" justify="space-between">
                            <el-col>
                                <el-row type="flex" class="row-bg after-login-data-total">
                                    <img src="../../../../assets/images/register.svg" width="54" height="54" alt />
                                    <el-col type="flex" class="after-login-data-list-total">
                                        <div class="after-login-data-list-total-top">{{$translate('lang.E3202102250001', { defaultText: '注册累计数：' })}}</div>
                                        <div class="after-login-data-list-total-bottom">{{registry.totalCount}}</div>
                                    </el-col>
                                </el-row>
                            </el-col>
                            <el-col :span="2">
                                <div @click="refreshGet('registry')" class="after-login-data-refresh"></div>
                            </el-col>
                        </el-row>
                        <span class="after-striping"></span>
                        <el-row type="flex" class="row-bg after-login-data-type" justify="space-between" align="middle">
                            <el-col class="after-login-data-number" :span="8">
                                {{$translate('lang.E3202110260003', { defaultText: '当年' })}}:
                                <b class="after-login-data-number-weight" :title="registry.yearCount">{{registry.yearCount}}</b>
                            </el-col>
                            <el-col class="after-login-data-number after-login-data-number-center" :span="8">
                                {{$translate('lang.E3202110260004', { defaultText: '当月' })}}:
                                <b class="after-login-data-number-weight" :title="registry.monthCount">{{registry.monthCount}}</b>
                            </el-col>
                            <el-col class="after-login-data-number" :span="8">
                                {{$translate('lang.E3202110260005', { defaultText: '当周' })}}:
                                <b class="after-login-data-number-weight" :title="registry.weekCount">{{registry.weekCount}}</b>
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col class="after-login-data" type="flex">
                        <el-row type="flex" class="row-bg" justify="space-between">
                            <el-col>
                                <el-row type="flex" class="row-bg after-login-data-total">
                                    <img src="../../../../assets/images/parse.svg" width="54" height="54" alt />
                                    <el-col type="flex" class="after-login-data-list-total">
                                        <div class="after-login-data-list-total-top">{{$translate('lang.E3202102250002', { defaultText: '解析累计数：' })}}</div>
                                        <div class="after-login-data-list-total-bottom">{{parse.totalCount}}</div>
                                    </el-col>
                                </el-row>
                            </el-col>
                            <el-col :span="2">
                                <div @click="refreshGet('parse')" class="after-login-data-refresh"></div>
                            </el-col>
                            </el-row>
                            <span class="after-striping"></span>
                            <el-row type="flex" class="row-bg after-login-data-type" justify="space-between" align="middle">
                                <el-col class="after-login-data-number" :span="8">
                                    {{$translate('lang.E3202110260003', { defaultText: '当年' })}}:
                                    <b class="after-login-data-number-weight" :title="parse.yearCount">{{parse.yearCount}}</b>
                                </el-col>
                                <el-col class="after-login-data-number after-login-data-number-center" :span="8">
                                    {{$translate('lang.E3202110260004', { defaultText: '当月' })}}:
                                    <b class="after-login-data-number-weight" :title="parse.monthCount">{{parse.monthCount}}</b>
                                </el-col>
                                <el-col class="after-login-data-number" :span="8">
                                    {{$translate('lang.E3202110260005', { defaultText: '当周' })}}:
                                    <b class="after-login-data-number-weight" :title="parse.weekCount">{{parse.weekCount}}</b>
                                </el-col>
                        </el-row>
                    </el-col>
                </el-row>
                <!-- 趋势图 -->
                <div class="tendency-chart">
                    <div class="gostatement" @click="goStatement"></div>
                    <el-tabs v-model="activeName" type="card" @tab-click="tabClick">
                        <el-tab-pane :label="$translate('lang.E3202110270003', { defaultText: '注册趋势' }) " name=1></el-tab-pane>
                        <el-tab-pane :label="$translate('lang.E3202110270004', { defaultText: '解析趋势' }) " name="2"></el-tab-pane>
                    </el-tabs>
                    <div class="tendency-chart-content">
                        <div :class="[tendencyType, tendencyposition]">
                            <span @click="tendencyChartChange('tendency-chart-line')" class="tendency-chart-type line-chart">
                            {{$translate('lang.E3202110260006', { defaultText: '折线图' })}}
                            </span>
                            <span @click="tendencyChartChange('tendency-chart-bar')" class="tendency-chart-type bar-chart">
                            {{$translate('lang.E3202110260007', { defaultText: '柱状图' })}}
                            </span>
                        </div>
                        <div id="tendency"></div>
                        <div class="ecahrt-unit">
                            {{$translate('lang.E3202102250013', { defaultText: '单位：次/日' })}}
                        </div>
                    </div>
                </div>
            </div>
            <!-- 最新公告、常见问题 -->
            <div class="after-login-index-right">
                <div class="new-dynamic-state">
                    <div class="new-dynamic-state-main">
                        <div>
                            <img src="../../../../assets/images/Questions.svg" alt class="after-small-title-img"  width="16" height="16" />
                            <span class="after-small-title-main">{{$translate('lang.E3202102250015', { defaultText: '常见问题' })}}</span>
                        </div>
                        <span class="after-striping"></span>
                        <ul class="notice-box">
                            <li v-for="item in issueList" :key="item.id" :id="item.id" @click="gotoDetails(item.id)" class="new-dynamic-state-main-list-item" >
                                <span class="new-dynamic-state-main-list-item-main">{{item.subject}}</span>
                                <span class="new-dynamic-state-main-list-item-date">{{item.updateTime}}</span>
                            </li>
                        </ul>
                    </div>
                    <div class="new-dynamic-state-main">
                        <div>
                            <img src="../../../../assets/images/notice.svg" class="after-small-title-img" width="16" height="16" />
                            <span class="after-small-title-main">{{$translate('lang.E3202102250014', { defaultText: '最新公告' })}}</span>
                        </div>
                        <span class="after-striping"></span>
                        <ul class="notice-box">
                            <li href="/detailsNotice"  v-for="item in noticeList" :id="item.id" :key="item.id" @click="gotoDetails(item.id)" class="new-dynamic-state-main-list-item" >
                                <span class="new-dynamic-state-main-list-item-main">{{item.subject}}</span>
                                <span class="new-dynamic-state-main-list-item-date">{{item.updateTime}}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <span class="bottom-main">Copyright@1968-2020 Midea Group all right reserved</span>
    </Paper>
</template>
<script>
import { getRows } from '../../../../api/afterLoginIndex';
import Paper from '@/components/core/paper/Paper';
import {
    getAnalysisReport,
    arrmax
} from '../../../../api/reportManagement';
import { searchNotic } from '../../../../../sn/api/systemManagementApi';
import { getEchartsOptions } from './echartsDataOptions';
import { mapGetters } from 'vuex';
export default {
    data() {
        return {
            activeName: '1', // 1-注册趋势，2-解析趋势
            refreshData: true,
            reporJump: false,
            noticeList: [],
            issueList: [],
            registry: {
                monthCount: '',
                weekCount: '',
                yearCount: '',
                totalCount: ''
            },
            parse: {
                monthCount: '',
                weekCount: '',
                yearCount: '',
                totalCount: ''
            },
            panorama: 'panorama',
            tendencyposition: 'tendencyposition',
            tendencyType: 'tendency-chart-line',
            searchData: {
                action: 'registry',
                prefixCode: '',
                year: '',
                month: ''
            },
            echartsData: {}
        };
    },
    components: {
        Paper
    },
    methods: {
        tabClick(current) { // echarts tab
            if (current.name) {
                this.showPanoramaCar(current.name);
                this.tendencyType = 'tendency-chart-line';// 切换tab时，默认展示折线图
            }
        },
        tendencyChartChange(type) {
            this.tendencyType = type;
            this.drawEcharts();
        },
        gotoDetails(id) {
            this.$router.push({
                path: '/detailsNotice',
                query: { id: id }
            });
        },
        // 获取问题，公告数据
        getNotice() {
            const parms = {
                subject: '',
                contentType: 1,
                pageNo: 1,
                pageSize: 99,
                orderBy: 'updateTime',
                orderByType: 'desc',
                state: 0
            };
            searchNotic(parms).then(res => {
                if (+res.code === 0) {
                    this.noticeList = res.data.list;
                }
            });
        },
        getissue() {
            const parms = {
                subject: '',
                contentType: 2,
                pageNo: 1,
                pageSize: 99,
                orderBy: 'updateTime',
                orderByType: 'desc',
                state: 0
            };
            searchNotic(parms).then(res => {
                if (+res.code === 0) {
                    this.issueList = res.data.list;
                }
            });
        },
        refreshGet(value) {
            if (this.refreshData) {
                this.refreshData = false;
                this.acquire(value);
            }
        },
        acquire(value) {
            getRows({ action: value }).then(res => {
                if (+res.code === 0) {
                    if (res.data[0].action === 'parse') {
                        Object.keys(this.parse).forEach(key => {
                            this.parse[key] = res.data[0][key].toLocaleString();
                        });
                    } else if (res.data[0].action === 'registry') {
                        Object.keys(this.registry).forEach(key => {
                            this.registry[key] = res.data[0][key].toLocaleString();
                        });
                    }
                }
                this.refreshData = true;
            }).catch(() => {
                this.refreshData = true;
            });
        },
        showPanoramaCar(data) {
            if (data === '1') {
                this.panorama = 'panorama';
                this.searchData['action'] = 'registry';
                const params = {
                    ...this.searchData
                };
                this.getData(params);
            }
            if (data === '2') {
                this.panorama = 'car';
                this.searchData['action'] = 'parse';
                const params = {
                    ...this.searchData
                };
                this.getData(params);
            }
        },
        getData(params) {
            this.echartsData = {};
            getAnalysisReport(params).then(res => {
                if (+res.code === 0) {
                    const XAxisData = [];
                    const otherDate = [];
                    res.data.map((item, index) => {
                        XAxisData.push(index + 1);
                        otherDate.push(item.count);
                    });
                    this.echartsData.XAxisData = XAxisData;
                    this.echartsData.max =
            (Math.floor(arrmax(otherDate) / 10) + 1) * 10;
                    this.echartsData.interval =
            ((Math.floor(arrmax(otherDate) / 10) + 1) * 10) / 10;
                    this.echartsData.seriesData = otherDate;
                    this.echartsData.seriesName =
            res.data[0].action === 'registry'
                ? this.$translate('lang.E3202102250017', { defaultText: '注册量' })
                : this.$translate('lang.E3202102250018', { defaultText: '解析量' });
                    this.echartsData.titleText =
            res.data[0].action === 'registry'
                ? this.$translate('lang.E3202102250012', { defaultText: '本月标签注册量' })
                : this.$translate('lang.E3202102250016', { defaultText: '本月标签解析量' });
                    this.drawEcharts();
                }
            });
        },
        drawEcharts() {
            const tendency = document.getElementById('tendency');
            if (tendency) {
                const myChart = this.$echarts.init(tendency);
                myChart.setOption(getEchartsOptions(this.echartsData, this.searchData['action'], this.tendencyType, this.$echarts));
                window.onresize = () => {
                    let myChart = this.$echarts.init(tendency);
                    myChart.dispose();
                    myChart = this.$echarts.init(tendency);
                    myChart.setOption(getEchartsOptions(this.echartsData, this.searchData['action'], this.tendencyType, this.$echarts));
                };
            }
        },
        getTime() {
            const statsTime = new Date();
            const year = statsTime.getFullYear().toString();
            const month = statsTime.getMonth() + 1;
            this.searchData.year = year;
            this.searchData.month = month;
        },
        async initGetData() {
            const params = {
                tenantCode: this.currentTenant.tenantCode
            };
            this.searchData['prefixCode'] = params.tenantCode;
            this.getTime();
            const data = {
                ...this.searchData
            };
            this.getData(data);
        },
        goStatement() {
            if (this.reporJump === true) {
                this.$router.push({
                    name: 'analysisReport',
                    query: { prefixCode: this.currentTenant.tenantCode }
                });
            } else {
                this.$message.warning(this.$translate('lang.EXC202102250001', { defaultText: '无权限访问报表' }));
            }
        },
        // 判断是否有跳转权限
        checkJump(authority) {
            authority.map(item => {
                if (item.resourceCode === 'RE202001190029') {
                    item.subResources.map(items => {
                        if (items.frontUrl === '/analysisReport') {
                            this.reporJump = true;
                        }
                    });
                }
            });
        }
    },
    mounted() {
        this.initGetData();
        this.checkJump(this.authority);
    },
    computed: {
        ...mapGetters(['user', 'currentTenant', 'authority'])
    },
    created() {
        this.acquire('registry');
        this.acquire('parse');
        this.getNotice();
        this.getissue();
    }
};
</script>
<style lang="less">
@import './afterLoginIndexStyle.less';
</style>